export default __webpack_public_path__ + "static/media/this-sunny-day.1c421561.mp3";